import React from "react";
import { Translate } from "react-auto-translate";
import { useHistory } from "react-router-dom";
import moment from "moment";

import defaultBanner from "./../../assets/images/default_image.svg";

import "./CardInformationCommon.scss";
import { TIME_FORMAT } from "../../settings/formatDateTime";
import FallbackImage from "../FallbackImage";

const getImagePaths = (image) => {
  if (!image) {
    return [];
  }

  if (typeof image === "string") {
    return [image];
  }

  if (typeof image === "object" && image.url) {
    return [image.url];
  }

  return [];
};

export default function CardInformationCommon({ data }) {
  const { header, image, title, description, id, path, date } = data;
  const history = useHistory();

  const handleInformationDetail = (id) => {
    history.push(`${path}${id}`);
  };

  return (
    <div className="commonCard">
      <div
        className="commonCard--image"
        onClick={() => handleInformationDetail(id)}
      >
        <FallbackImage
          variant="fill"
          paths={getImagePaths(image)}
          fallback={defaultBanner}
          alt={title || "banner infomation"}
        />
      </div>

      {id && (
        <p
          onClick={() => handleInformationDetail(id)}
          className="commonCard--title"
        >
          <p>{title}</p>
        </p>
      )}
      {description && (
        <p
          className="commonCard--description"
          onClick={() => handleInformationDetail(id)}
        >
          <Translate>{description}</Translate>
        </p>
      )}
      {date && (
        <div className="commonCard--date">
          <hr />
          <p>
            {moment(date, ["YYYY-MM-DD", "DD.MM.YYYY"]).format(
              TIME_FORMAT?.DOT_DATE_FORMAT
            )}
          </p>
        </div>
      )}
    </div>
  );
}
